import { render } from "./ToButton.vue?vue&type=template&id=60e7fe41&ts=true"
import script from "./ToButton.vue?vue&type=script&lang=ts"
export * from "./ToButton.vue?vue&type=script&lang=ts"

import "./ToButton.vue?vue&type=style&index=0&id=60e7fe41&lang=css"

import exportComponent from "C:\\vue项目\\baiduobang\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__